import axios from "axios";
import { getAPIUrl } from "../config";
import { headerConfig } from "./authConfig";
import { clearLocalStorage } from "./userStorage";

const serviceEndPoint = `${getAPIUrl()}/api/user`;

const handleApiError = (error, showToast) => {
    const status = error.response?.status || "Network Error";
    const message = error.response?.data?.message || error.message;

    if (showToast) {
        showToast(message, "error"); 
    }
    setTimeout(() => {
        clearLocalStorage(); 
    }, 500);

    return { status, message };
};

export const getUserData = async (showToast) => {
  try {
    const result = await axios.get(serviceEndPoint, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};
export const addUserData = async (data, showToast) => {
  try {
    const result = await axios.post(serviceEndPoint, data, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const getUserById = async (userId, showToast) => {
  try {
    const result = await axios.get(`${serviceEndPoint}/${userId}`, headerConfig());
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};
export const updateUserData = async (data, showToast) => {
  try {
    const result = await axios.put(
      serviceEndPoint,
      {
        id: data._id,
        name: data.name,
        password: data.password,
        email: data.email,
        phone: data.phone,
        active: data.active,
        role: data.role,
      },
      headerConfig()
    );
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};

export const deleteUser = async (id, showToast) => {
  try {
    const result = await axios.delete(serviceEndPoint, {
      data: { id },
      ...headerConfig(),
    });
    return result.data;
  } catch (error) {
    return handleApiError(error, showToast);
  }
};